
  import { Component, Prop, Vue }                               from 'vue-property-decorator';
  import { ConfigThemeService, EventBus }                       from '../../';
  import   simplebar                                            from 'simplebar-vue';
  import   '/src/assets/js/simplebar/dist/simplebar.min.css';

  
  @Component({
    name: 'CarouselComponent',
    components: {
      simplebar
    }
  })
  export default class CarouselComponent extends Vue {
    @Prop() carouselStyles!: any;
    @Prop() tabClassName?:string;
    @Prop() allElements?: NodeListOf<HTMLElement> | null;
    @Prop() elementIndex?: number;
    @Prop() iconColor?:string;
    @Prop() iconBgColor?:string;

    /** ******************************************************************** */
    /**                      rendering function                              */
    /** ******************************************************************** */
    isImageElement(elem: HTMLElement) {
      return elem instanceof HTMLImageElement;
    }

    isTableElement(elem: HTMLElement) {
      return elem instanceof HTMLTableElement;
    }

    get carouselElements() {
      return this.allElements ? this.allElements : [];
    }

    get carouselElemIndex() {
      return this.elementIndex ? this.elementIndex : 0;
    }

    /** ******************************************************************** */
    /**                      get styles                                      */
    /** ******************************************************************** */

    get leftNavigationIcon() {
      return ConfigThemeService.getLeftNavigationIcon();
    }

    get rightNavigationIcon() {
      return ConfigThemeService.getRightNavigationIcon();
    }

    get loadingAnimationColor() {
      return ConfigThemeService.getLoadingAnimationColor(this.$vuetify);
    }

    /** ******************************************************************** */
    /**                      LIFECYCLE HOOKS FUNCTIONS                       */
    /** ******************************************************************** */
    mounted() {
      this.updateColors();
    }

    updated() {
      this.updateColors();
    }

    updateColors(){
      // update the arrows color 
      let buttonElems: NodeListOf<HTMLElement> | null = this.$el ? this.$el.querySelectorAll('button') : null;
      if(buttonElems){
        buttonElems.forEach(element => {
          element.style.color = this.iconColor ? this.iconColor : '';
          element.style.backgroundColor = this.iconBgColor ? this.iconBgColor : '';
        });
      }

      // update the scrollbar color
      let scrollbarElement: HTMLElement | null = document.getElementById('bot-carousel-component');
      if(scrollbarElement){
        scrollbarElement.style.setProperty('--scrollbarBackground', ConfigThemeService.getScrollbarColor(this.$vuetify));
      }
    }

    emitClosePopUp() {
      // Send the event on a channel (CLOSE_POP_UP)
      EventBus.$emit('CLOSE_POP_UP'); 
    }
  }
